/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eventemailssetting2Inputs */

const en_eventemailssetting2 = /** @type {(inputs: Eventemailssetting2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mails about my events`)
};

const de_eventemailssetting2 = /** @type {(inputs: Eventemailssetting2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-Mails über meine Events`)
};

/**
* | output |
* | --- |
* | "E-mails about my events" |
*
* @param {Eventemailssetting2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const eventemailssetting2 = /** @type {((inputs?: Eventemailssetting2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eventemailssetting2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_eventemailssetting2(inputs)
	return de_eventemailssetting2(inputs)
});
export { eventemailssetting2 as "eventEmailsSetting" }